import React from "react";
import WeatherReact from "./WeatherReact.js";
import "./App.css";

export default function App() {
  return (
    <div className="App">
      <div className="container">
        <WeatherReact defaultCity="Nigeria" />
        <footer className="App-header">
          This React Weather Project was coded by Uche Okafor and it is an{" "}
          <a
            href="https://github.com/ucheidm/react_weather_app"
            target="_blank"
            rel="noreferrer"
          >
            Open-Source Code in GitHub
          </a>{" "}
          and hosted on{" "}
          <a
            href="https://zesty-pixie-8cb16a.netlify.app/"
            target="_blank"
            rel="noreferrer"
          >
            Netlify
          </a>
        </footer>
      </div>
    </div>
  );
}
